import { getAppVersion } from '@/utils/app'

const webVersion = import.meta.env.VITE_CLIENT_VERSION || 0

export async function getFullVersion() {
  return `${await getAppVersion()}/${webVersion}`
}

export async function getFormatVersion() {
  const version = await getAppVersion()
  const verL = version.toLowerCase()
  if (verL === 'web') {
    return `Web: ${webVersion}`
  }
  if (verL.startsWith('android')) {
    const reg = /android:/i
    const appVersion = version.replace(reg, 'Android: ')
    return `${appVersion}/${webVersion}`
  }
  if (verL.startsWith('ios')) {
    const reg = /ios:/i
    const appVersion = version.replace(reg, 'iOS: ')
    return `${appVersion}/${webVersion}`
  }
  return `app-error/${webVersion}`
}
